import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { useBreakpointValue as a, Flex as l } from "@chakra-ui/react";
import { Button as o } from "../../forms/Button/Button.mjs";
import "../../forms/Button/IconButton.mjs";
import "../../forms/Button/ButtonGroup.mjs";
const f = ({ onCancelClick: e, onContinueClick: t }) => {
  const i = a({ base: !0, md: !1 }, { fallback: "md" });
  return /* @__PURE__ */ s(l, { gap: 3, width: "100%", justifyContent: { base: "space-between", md: "flex-end" }, children: [
    /* @__PURE__ */ r(
      o,
      {
        size: "sm",
        variant: "tertiary",
        isFullWidth: i,
        ...e && { onClick: e },
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ r(
      o,
      {
        size: "sm",
        variant: "primary",
        isFullWidth: i,
        ...t && { onClick: t },
        children: "Continue"
      }
    )
  ] });
};
export {
  f as ModalDefaultFooter
};
